import { getPrimaryTag, TOrgTheme } from "@eventr/common";
import type { BoundStore } from "state/bound.store";

/**
 * The theme the selected itinerary renders in on Device: the one its primary tag names, if
 * any. With no tag theme, Device follows the OS light/dark setting, so the organisation
 * default theme is deliberately not a fallback here (unlike `getEffectiveTheme`).
 *
 * Returns a reference out of `orgConfig.themes`, so selecting on it directly is stable.
 */
export const selectEffectiveTheme = (s: BoundStore): TOrgTheme | undefined => {
  const tagIds = s.itineraryMap?.find((itinerary) => itinerary?.id === s.selectedItinID)?.tags;
  const themeId = getPrimaryTag(tagIds, s.orgConfig?.itinTags ?? [])?.properties?.themeId;
  if (!themeId) return undefined;
  // `config.themes` is `false` rather than `[]` on orgs that have never had a theme.
  const themes = Array.isArray(s.orgConfig?.themes) ? s.orgConfig.themes : [];
  // A tag can name a theme that has since been deleted, which falls back to the device too.
  return themes.find((theme) => theme._id === themeId);
};
